// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"bb78e339","436":"3017b311"}[chunkId] + ".chunk.js";
};